export default "__VITE_ASSET__BhvPtnsI__"